import { render, staticRenderFns } from "./OptionFilter.vue?vue&type=template&id=5f13ee7d&scoped=true&"
import script from "./OptionFilter.vue?vue&type=script&lang=js&"
export * from "./OptionFilter.vue?vue&type=script&lang=js&"
import style0 from "./OptionFilter.vue?vue&type=style&index=0&id=5f13ee7d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f13ee7d",
  null
  
)

export default component.exports